const API_KEY = 'vdhy8wwjUJrwhxFpfuECTiAW'
const CARRIER_VIEW_URL = 'https://api.shippersedge.com/schedule/carrierView/'

const attempt = (driverCode, queryString, timeoutMs) =>
    new Promise((resolve) => {
        const controller = new AbortController()
        const timer = setTimeout(() => controller.abort(), timeoutMs)
        fetch(`${CARRIER_VIEW_URL}${queryString}`, {
            method: 'POST',
            headers: { 'x-api-key': API_KEY, 'Content-Type': 'application/json' },
            body: JSON.stringify({ driverCode, mode: 'quickSchedule' }),
            signal: controller.signal,
            redirect: 'follow'
        })
            .then(r => { if (!r.ok) throw new Error(r.statusText); return r.json() })
            .then(data => { clearTimeout(timer); resolve(data) })
            .catch(() => { clearTimeout(timer); resolve(null) })
    })

const getQuickScheduleData = async (driverCode, queryString = '') => {
    if (!driverCode) return null
    for (const timeout of [10000, 20000, 45000]) {
        const result = await attempt(driverCode, queryString, timeout)
        if (result && typeof result === 'object') return result
    }
    console.warn('getQuickScheduleData: all 3 attempts failed')
    return null
}

export default getQuickScheduleData
